import styled from 'styled-components';

/**
 * 한 행 안에 조건 여러 개를 나란히 둔다 (AMZUWEB-682).
 *
 * `SearchBox` 는 행마다 여백 20px + 구분선을 붙이므로, 조건 하나에 한 행씩 쓰면
 * 검색 영역만으로 화면이 다 찬다. 성격이 같은 것끼리 묶어 행 수를 줄인다
 * (주문/배송관리·멀티채널 주문관리가 쓰는 방식).
 */
export const StyledFieldRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 24px;
`;

/** 한 행에 여러 조건이 오면 어느 컨트롤이 무엇인지 잃어버리므로 컨트롤마다 작은 이름표를 단다 */
export const StyledLabeled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .sub-label {
    font-size: 13px;
    color: #6b7280;
    white-space: nowrap;
  }
`;

export const StyledHint = styled.span`
  font-size: 12px;
  color: #9ca3af;
`;
